<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="
      cuti && cuti.cuti_id
        ? 'Ubah Ajuan Ketidakhadiran'
        : 'Tambah Ajuan Ketidakhadiran'
    "
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row row wrap justify="center" align="center">
              <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
                <label class="caption mb-2 primary--text"
                  >Kategori Ketidakhadiran</label
                >
                <v-select
                  :disabled="edit ? true : false"
                  autofocus
                  dense
                  single-line
                  outlined
                  v-model="jenisCuti"
                  data-vv-name="jenis"
                  data-vv-as="Jenis"
                  :items="kategoriCuti"
                  @change="changeJenis()"
                  item-text="nama"
                  hint="Kategori Ketidakhadiran"
                  item-value="id"
                  :return-object="true"
                  label="Kategori Ketidakhadiran"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.jenis')"
                  no-data-text="Belum tersedia kategori ketidakhadiran yang dibuat"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" class="py-0">
                <label class="caption mb-2 primary--text">Pilih Anggota</label>
                <v-autocomplete
                  dense
                  :disabled="edit ? true : false"
                  single-line
                  outlined
                  v-model="cuti.user_id"
                  :items="users"
                  label="Pilih Anggota"
                  persistent-hint
                  item-text="nama"
                  @change="cekSaldo"
                  item-value="user_id"
                  data-vv-name="user"
                  data-vv-as="Anggota"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.user')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-if="showSaldo">
                <v-alert
                  text
                  dense
                  color="blue"
                  icon="mdi-information-outline"
                  border="left"
                  >Kategori Ketidakhadiran ini menerapkan Saldo Cuti. Sisa Saldo
                  Cuti Anda {{ jenisCuti.cuti_kategori_id ? saldoShow[jenisCuti.cuti_kategori_id] || 0 : 0 }} hari</v-alert
                >
              </v-col>
            </v-row>

            <v-row row wrap>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
                v-if="$vuetify.breakpoint.smAndUp"
              >
                <v-btn
                  tile
                  :outlined="rangeDate == false ? false : true"
                  @click="rangeDate = false"
                  depressed
                  color="primary"
                >
                  <v-icon>mdi-calendar</v-icon>Satu Hari
                </v-btn>
                <v-btn
                  tile
                  :outlined="rangeDate == true ? false : true"
                  @click="rangeDate = true"
                  depressed
                  color="primary"
                >
                  <v-icon>mdi-calendar</v-icon>Beberapa Hari
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" v-else>
                <v-radio-group v-model="rangeDate">
                  <v-radio label="Satu Hari" :value="false"></v-radio>
                  <v-radio label="Beberapa Hari" :value="true"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2 primary--text">Tanggal Awal</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Awal"
                  v-model="tanggalAwal"
                  hint="Tanggal Awal"
                  :max="tanggalAkhir"
                  data-vv-name="tanggalAwal"
                  data-vv-as="Tanggal Awal"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAwal')"
                ></m-datepicker>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                v-show="this.rangeDate"
                class="py-0"
              >
                <label class="caption mb-2 primary--text">Tanggal Akhir</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Akhir"
                  v-model="tanggalAkhir"
                  :min="tanggalAwal"
                  :max="maxAjuan"
                  hint="Tanggal Akhir"
                  data-vv-name="tanggalAkhir"
                  data-vv-as="Tanggal Akhir"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAkhir')"
                ></m-datepicker>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2 primary--text">Keterangan</label>
                <v-textarea
                  dense
                  single-line
                  outlined
                  label="Keterangan"
                  v-model="cuti.keterangan"
                  hint="Keterangan"
                  data-vv-name="keterangan"
                  data-vv-as="Keterangan"
                  v-validate="
                    jenisCuti && jenisCuti.is_keterangan ? 'required' : ''
                  "
                  rows="2"
                  :error-messages="errors.collect('form.keterangan')"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2 primary--text"
                  >Lampiran Berkas</label
                >
                <p v-if="edit && cuti.file">
                  Berkas :
                  <a :href="cuti.file.url_lampiran" target="_blank">{{
                    pVal(cuti.file, "filename")
                  }}</a>
                </p>
                <div class="container">
                  <v-file-input
                    dense
                    single-line
                    outlined
                    ref="file"
                    v-model="file"
                    :hint="'*Ukuran berkas maksimal ' + maxSize + ' MB'"
                    persistent-hint
                    id="file"
                    @change="handleFileUpload"
                    :placeholder="edit ? 'Ubah Berkas' : 'Pilih Berkas'"
                    :accept="accepts"
                    name="File"
                    data-vv-name="file"
                    data-vv-as="Berkas"
                    v-validate="
                      edit
                        ? ''
                        : jenisCuti && jenisCuti.is_lampiran
                        ? 'required'
                        : ''
                    "
                    :error-messages="errors.collect('form.file')"
                  ></v-file-input>
                  <!-- <p class="error--text" v-if="errorType">Tipe berkas Anda tidak memenuhi syarat.</p>
                  <p
                    class="error--text"
                    v-if="this.file&&this.size > this.maxSize"
                  >Ukuran Berkas Anda melebihi ketentuan : {{this.size}} MB</p>-->
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
import moment from "moment";
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      edit: false,
      users: [],
      jenisCuti: null,
      showSaldo: false,
      sisaSaldo: null,
      kategoriCuti: [],
      file: null,
      maxSize: 2,
      accepts: ["application/pdf", "image/*"].join(","),
      rangeDate: false,
      maxAjuan: null,
      tanggalAwal: null,
      tanggalAkhir: null,
      isDisabled: false,
      cuti: {},
      defCuti: {
        user_id: null,
        tgl_awal: new Date().toISOString().substr(0, 10),
        tgl_akhir: new Date().toISOString().substr(0, 10),
        keterangan: null
      }
    };
  },
  computed: {
    saldoShow() {
      const items = this.sisaSaldo || []
      let temp = {}
      items.forEach((item) => {
        this.$set(temp, item.cuti_kategori_id, item.sisa)
      })

      return temp
    }
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset();
      this.isDisabled = false;
      this.rangeDate = false;
      this.maxAjuan = null;
      this.getUser();
      this.loadKategoriCuti();
      this.showSaldo = false;
      this.sisaSaldo = null;
      this.cuti = obj
        ? {
            ...obj,
            ...(this.jenisCuti = { ...obj.cuti_kategori }),
            ...(this.isDisabled = true),
            ...(this.edit = true),
            ...(this.tanggalAwal = obj.tgl_awal),
            ...(this.tanggalAkhir = obj.tgl_akhir),
            ...(this.rangeDate = true)
          }
        : {
            ...this.defCuti,
            ...(this.file == null),
            ...(this.edit = false),
            ...(this.jenisCuti = null),
            ...(this.tanggalAwal = null),
            ...(this.tanggalAkhir = null)
          };
      return this.$refs.dlg.open();
    },
    getUser() {
      this.$store
        .dispatch("user/getUserAktif", { organisasi_id: this.organisasi_id })
        .then(res => {
          this.users = [...res.data];
        });
    },
    loadKategoriCuti() {
      this.$store
        .dispatch("kategori/get", {
          organisasi_id: this.organisasi_id,
          params: {
            format: 'json',
            is_aktif: 1
          }
        })
        .then(res => {
          this.kategoriCuti = res.data || [];
        })
        .catch(e => e);
    },
    changeJenis() {
      this.cuti.user_id = null;
      this.tanggalAwal = null;
      this.tanggalAkhir = null;
      this.cuti.keterangan = null;
      this.cuti.file = null;
    },
    handleFileUpload() {
      // this.errorType = false;
      // if (this.file) {
      //   if (this.file.type != "application/pdf") {
      //     this.errorType = true;
      //   }
      //   this.size = (this.file.size / 1000000).toFixed(2);
      // }
    },
    cekSaldo() {
      if (this.jenisCuti && this.jenisCuti.is_saldo) {
        var objSaldo = {
          cuti_kategori_id: this.jenisCuti.cuti_kategori_id,
          user_id: this.cuti.user_id,
          tahun: new Date().getFullYear()
        };
        return this.$store
          .dispatch("cuti/cekSaldo", {
            obj: objSaldo,
            organisasi_id: this.organisasi_id
          })
          .then(res => {
            this.showSaldo = true;
            this.sisaSaldo = res.data;
          });
      }
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          if (this.jenisCuti.is_saldo == 1 && this.sisaSaldo > 0) {
            this.cuti.cuti_kategori_id = this.jenisCuti.cuti_kategori_id;
            this.cuti.tgl_awal = this.tanggalAwal;
            this.cuti.tgl_akhir = this.tanggalAkhir;
            this.cuti.lampiran = this.file;
            return this.$store.dispatch("cuti/form", {
              obj: this.cuti,
              organisasi_id: this.organisasi_id
            });
          } else if (this.jenisCuti.is_saldo == 1 && this.sisaSaldo <= 0) {
            this.$error("Saldo tidak mencukupi");
          } else {
            this.cuti.cuti_kategori_id = this.jenisCuti.cuti_kategori_id;
            this.cuti.tgl_awal = this.tanggalAwal;
            this.cuti.tgl_akhir = this.tanggalAkhir;
            this.cuti.lampiran = this.file;
            return this.$store.dispatch("cuti/form", {
              obj: this.cuti,
              organisasi_id: this.organisasi_id
            });
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$info("Simpan Data Berhasil");
            this.$refs.dlg.resolve();
            return res;
          } else {
            this.$error("Simpan Data Gagal");
            this.$refs.dlg.resolve();
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    jenisCuti() {
      this.maxAjuan = null;
    },
    tanggalAwal(n) {
      this.tanggalAkhir = null;
      if (this.jenisCuti && this.jenisCuti.max_ajuan > 0) {
        var new_date = moment(n).add(this.jenisCuti.max_ajuan - 1, "days");
        this.maxAjuan = new_date.format("YYYY-MM-DD");
      }
      if (!this.rangeDate) {
        this.tanggalAkhir = this.tanggalAwal;
      }
    },
    rangeDate(m) {
      if (!m) {
        this.tanggalAkhir = this.tanggalAwal;
      }
    }
  }
};
</script>
